import { render, staticRenderFns } from "./footerNotice.vue?vue&type=template&id=400a25bc&"
import script from "./footerNotice.vue?vue&type=script&lang=js&"
export * from "./footerNotice.vue?vue&type=script&lang=js&"
import style0 from "./footerNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports